import { FC } from 'react';

import { Checkbox } from '@telialt/common-checkbox/src';
import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { Tooltip } from '@telialt/common-tooltip/src';
import { withParams } from '@telialt/utils/src/helpers';

import { SEARCH_TEST_ID } from '../../test/test-ids';
import { CheckboxWrapper, SkipToCompareLink } from './ProductCard.styles';

type Props = {
    isCompareChecked?: boolean;
    isCompareDisabled?: boolean;
    compareDisabledMessage?: string;
    productName: string;
    onCompare?: (checkedStatus: boolean) => void;
};

export const CompareRow: FC<Props> = ({
    isCompareChecked,
    isCompareDisabled,
    compareDisabledMessage,
    productName,
    onCompare,
}) => {
    const { t } = useTranslations();

    if (!onCompare) {
        return null;
    }

    const compareCheckbox = (
        <>
            <Checkbox
                aria-label={withParams(t['search.component.product_card.compare_a11y_label'], { productName })}
                dataTest={SEARCH_TEST_ID.COMPARE_ITEM_CHECKBOX}
                label={t['search.component.product_card.compare']}
                checked={isCompareChecked}
                disabled={isCompareDisabled}
                onChange={onCompare as (checkedStatus: string | boolean) => void}
            />
            {isCompareChecked && (
                <SkipToCompareLink href="#compared-products" variant="text">
                    {t['search.component.product_card.skip_to_compare']}
                </SkipToCompareLink>
            )}
        </>
    );

    return (
        <CheckboxWrapper>
            {isCompareDisabled && compareDisabledMessage ? (
                <Tooltip content={compareDisabledMessage} shouldOpenOnHover={true}>
                    <div>{compareCheckbox}</div>
                </Tooltip>
            ) : (
                compareCheckbox
            )}
        </CheckboxWrapper>
    );
};
